import styled from '@emotion/styled'
import theme from '../../../../../styles/theme'

export const FooterPanel = styled.div`
  position: sticky;
  bottom: 0;
  border-radius: 1rem;
  background-color: color-mix(in srgb, white 30%, ${theme.colors.primary});
  margin-bottom: 1rem;

  border: 1px solid #e5e5ea;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 11;
  transform: translateY(1rem);
  margin-bottom: 3rem;
  padding-top: 2rem;
  padding-right: 7rem;
  padding-left: 6rem;
  padding-bottom: 2.4rem;
`

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CheckboxGroupContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-right: 1.5rem;
`

export const ActionSection = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  width: 2rem;
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.4))
    drop-shadow(0 0 6px rgba(255, 255, 255, 0.4));
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
`
